import React from "react";
import { CalculateOutlined, ContactsOutlined, EditOutlined, HomeOutlined, InfoOutlined, MenuOutlined, PersonOffOutlined, Settings, SsidChart } from "@mui/icons-material";

import { MenuRoute } from "./toolympus/components/frame";
import { SystemSubmenu } from "./toolympus/components/Contests/SystemSubmenu";
import { ProcessListPage, ProjectsListPage } from "./components/Projects";
import { SettingsPage } from "./components/Settings/SettingsPage";
import { Documentation, DocumentationStartPage } from "./components/Documentation";
import { GanttListPage, GanttPageLoaded } from "./components/Gantt";
import { B24IntegrationSettingsPage } from "./components/Settings/B24";
import { CRMRoutes } from "./toolympus/components/CRM";
import { isCalculationsUser, isCRMUser, userIsCRMExportUser } from "./components/Auth";
import { AbsenceCalendarPage } from "./components/Org/Absence";
import { EditorPlanPage } from "./components/Projects/Planning";
import { CalculatorRoutes, CalculationsListPage } from "./components/Projects/Calculator";


const InnerRoutes: MenuRoute[] = [
  {
    path: "/start",
    title: "Домашняя",
    icon: <HomeOutlined />,
    component: DocumentationStartPage,
  },
  {
    path: "/p",
    title: "Проекты",
    icon: <MenuOutlined />,
    component: ProjectsListPage,
  },
  {
    path: "/c",
    title: "Процессы",
    icon: <SsidChart />,
    component: ProcessListPage,
  },


  
  {
    path: "/editor-plan",
    title: "План вычитки",
    icon: <EditOutlined />,
    component: EditorPlanPage,
  },


  {
    path: "/org/crm",
    title: "CRM",
    icon: <ContactsOutlined />,
    alsoActivateForPath: p => p.startsWith("/org/crm/"),
    component: CRMRoutes,
    componentProps: { apiPath: "/api/crm", checkCanExport: userIsCRMExportUser },
    resolveHidden: isCRMUser,
    // noContentBg: true,
  },


  {
    path: "/g/:id",
    title: "Гантт",
    hidden: true,
    icon: <SsidChart />,
    component: GanttPageLoaded,
  },
  {
    path: "/g",
    title: "Гантт",
    hidden: true,
    icon: <SsidChart />,
    component: GanttListPage,
  },

  {
    path: "/absence",
    title: "Отсутствия",
    icon: <PersonOffOutlined />,
    component: AbsenceCalendarPage,
  },

  {
    path: "/calculations",
    title: "Расчеты",
    icon: <CalculateOutlined />,
    component: CalculationsListPage,
    resolveHidden: isCalculationsUser,
  },

  {
    path: "/calculators",
    title: "Калькуляторы",
    icon: <CalculateOutlined />,
    component: () => <CalculatorRoutes apiPath="/api/calculations/config" />,
    hidden: true,
  },
  
  { 
    path: '/system',
    title: 'Конфигурация',
    icon: <Settings />,
    resolveHidden: (roles) => !!roles?.includes("admin"),
    component: () => (
        <SystemSubmenu
            emails={{ apiPath: "/emails" }}
            dictionaries={{ apiPath: "/api/settings/dictionaries", hideDictionaries: ["users"] }}
            users={{ allowInvites: true, allowPaswordReset: true, allowPaswordChange: true, twoFactorAuthEnabled: true }}
            queryConsole={{}}
            cms={{ apiPath: "/api/cms" }}
            robud={{}}
            extraItems={[
              {
                label: "Настройки",
                key: "settings",
                icon: <Settings />,
                items: [{ component: SettingsPage, key: "settings", label: "Настройки" }],
              },
              {
                label: "Настройки Б24",
                key: "b24-settings",
                icon: <Settings />,
                items: [{ component: B24IntegrationSettingsPage, key: "b24-settings", label: "Настройки Б24" }],
              },

              {
                key: "documentation",
                label: "Документация",
                icon: <InfoOutlined />,
                items: [{ key: "documentation", label: "", component: Documentation }]
              },
            ]}
        />),
  },
];

export default InnerRoutes;